import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/app/servicos/manutencao-celulares-tablets/ManutencaoCelularesTabletsPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/ServicePageWrapper.tsx");
